(function($){
  $.fn.moveTo = function(selector){
    return this.each(function(){
      var cl = $(this).clone();
      $(cl).appendTo(selector);
      $(this).remove();
      
    });
  };
})(jQuery);


jQuery(function() {
  if(jQuery('#rev_slider').length > 0)
    jQuery('#rev_slider').show().revolution({
      dottedOverlay: 'none',
      delay: 5000,
      startwidth: 1920,
      startheight: 1060,

      hideThumbs:200,
      thumbWidth:100,                            
      thumbHeight:50,
      thumbAmount:5,

                         
      onHoverStop:"on",        

      navOffsetHorizontal:0,
      navOffsetVertical:20,

      swipe_velocity: 0.7,
      swipe_min_touches: 1,
      swipe_max_touches: 1,
      drag_block_vertical: false,

      spinner: 'spinner2',
      keyboardNavigation: 'on',

      navigationHAlign: 'center',
      navigationVAlign: 'bottom',
      navigationHOffset: 20,
      navigationVOffset: 20,

      soloArrowLeftHalign: '',
      soloArrowLeftValign: '',
      soloArrowLeftHOffset: 0,
      soloArrowLeftVOffset: 0,

      soloArrowRightHalign: '',
      soloArrowRightValign: '',
      soloArrowRightHOffset: 0,
      soloArrowRightVOffset: 0,

      shadow: 0,
      fullWidth: 'on',
      fullScreen: 'off', 

      stopLoop: 'off',
      stopAfterLoops: -1,
      stopAtSlide: -1,

      shuffle: 'off',
      autoHeight: 'off',
      forceFullWidth: 'off',
      hideTimerBar: 'on',

      hideNavDelayOnMobile: 1500,
      hideThumbsOnMobile: 'off',
      hideBulletsOnMobile: 'off',
      hideArrowsOnMobile: 'off',
      hideThumbsUnderResolution: 0,

      hideSliderAtLimit: 0,
      hideCaptionAtLimit: 0,
      hideAllCaptionAtLilmit: 0,
      startWithSlide: 0
    });
  /* End Home Slider */
});


(function($) {


  $(document).ready(function() {
    engo.init();
  }); 

  $(document).on('click','.overlay,.continue-shopping, .close-window', function() {   
    hidePopup('.engo-popup'); 

    setTimeout(function(){
      $('.loading').removeClass('loaded-content');
    },500);
    return false;
  });

//   $('.dropdown-toggle').on('click', function() {
// //     $('.dropdown-content').removeClass('active');
//     $(this).next().toggleClass('active');    
//     return false;
//   });  

  var engo = { 
    init: function() {
      this.initHideDropdown();
      this.initToggle(); 

      this.initSearch();
      this.initDropDownCart();

      this.initProductAddToCart();
      this.initProductAddToCartMulti();
      this.initSampleAddToCart();

      /* Mobile Menu */
      this.verticalToggleMenu();

    },

    /* Hide Dropdown */
    initHideDropdown: function(){
      $(document).on('click touchstart', function(e) {
        var mobileMenu = $(".main-menu");
        var topCart = $(".topCart");
        var dropdown = $(".dropdown-content");
        if (!mobileMenu.is(e.target) && mobileMenu.has(e.target).length === 0 && !topCart.is(e.target) && topCart.has(e.target).length === 0 && !dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
          mobileMenu.removeClass('active');
          topCart.removeClass('active');
          dropdown.removeClass('active');      
        }
      });
    },
    
    

    verticalToggleMenu: function() {            
      $('.toggle-dropdown-menu ul li.item-toggle-dropdown').each(function(){
        if ($(this).find('.item-toggle-menu').length > 0) {
          $(this).append('<i class="toggle-button fa fa-angle-right"></i>');
        }
        $(this).find('.item-toggle-menu').slideUp('fast');
        $(this).children('a').on("click",function(e){
          e.preventDefault();
          $(this).parent().find('.item-toggle-menu').toggle('Show');
          $(this).parent().find('.toggle-button').toggleClass('opened');
        });
      });
    },


    /* Dropdown Toggle */
    initToggle: function(){
//     $('.caret').click(function() {        
//     $(this).parent().next().toggleClass('active');        
//     return false; 
//   }); 

  $(".block-category .sub-menu > li").each( function(){
    if($(this).hasClass('active')){
      $(this).parent().addClass('active');
    }
  });

//   $('.dropdown-toggle').click(function() {
//     $('.dropdown-content').removeClass('active');
//     $(this).next().toggleClass('active');    
//     return false;              
//   });   
},

 /* --------------------------------------------------------- */
 /* Search */
 initSearch: function() {
  $('.btn-search').click(function(event) {   
    showPopup('.search-popup');
    event.preventDefault();      

  });     

},  

  /* --------------------------------------------------------- */
  /* Mobile Menu */
  initMobileMenu: function() {

    $('.mobile-menu').click(function() {      
      $(this).parent().toggleClass('active');    
      return false; 
    });   
  }, 


    /* Check Item Mini Cart */
    checkItemsInMiniCart: function() {
      if($('.mini-cart .mini-products-list').children().length > 0) {
        $('.mini-cart').addClass('hasItem');          
      } else{
        $('.mini-cart').removeClass('hasItem'); 
      }
    },

      /* Mini Cart Click to Show */
      initDropDownCart: function() {      
        $('.dropdow .cartCount').click(function() {
          $(this).parent('.topCart').toggleClass('active');
        });            
        engo.checkItemsInMiniCart();

        $('.mini-cart .btn-remove').click(function(event) {       
          event.preventDefault();
          var productId = $(this).parents('.item').attr('id');
          productId = productId.match(/\d+/g);
          Shopify.removeItem(productId, function(cart) {
            doUpdateMiniCart(cart);       
          });
        });
      },



        /* ------------------------------- */
        /* Product detail - Add to cart */

        initProductAddToCart: function() {
          $('#product-addTocart').click(function(event) {
 			console.log('baaaaal- 1');
            event.preventDefault();
            if ($(this).attr('disabled') != 'disabled') {
              var variant_id = $('#AddToCartForm select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#AddToCartForm input[name=id]').val();
              }

              var quantitynormal = $('#AddToCartForm input[name=quantity]').val();
              
              if (!quantitynormal) {
                quantitynormal = 1;
              }
              console.log('QuantityNormal:' + quantitynormal)
              var title = $('h1.product-name').html();
              var image = $('#ProductPhotoImg').attr('src');

              doAjaxAddToCart(variant_id, quantitynormal, title, image);
			
            }

            return false;
          });

        },
    
    initProductAddToCartMulti: function() {
          $('#AddToCartMulti').click(function(event) {
console.log('baaaaal- 2');
            event.preventDefault();
            console.log('start'+ quantitymulti)
            
            if ($(this).attr('disabled') != 'disabled') {
              var variant_id = $('#AddToCartFormMulti select[name=id]').val();
              if (!variant_id) {
                variant_id = $('#AddToCartFormMulti input[name=id]').val();
              }
              var quantitymulti = $('#AddToCartFormMulti select[name=quantity]').val();
              
              console.log('QuantityMulti:' + quantitymulti)
              
              var title = $('h1.product-name').html();
              var image = $('.product-featured-image').attr('src');

              doAjaxAddToCart(variant_id, quantitymulti, title, image);
			 $('#AddToCartMulti').attr('disabled','disabled');
             $('.quantity-selector').prop('selectedIndex',0);
              $('#AddToCartMulti span').html('Please select a quantity');
            }

            return false;
          });

        },
    
    initSampleAddToCart: function() {
          $('#SampleForm').click(function(event) {
            event.preventDefault();
            console.log('baaaaal- 3');
            if ($(this).attr('disabled') != 'disabled') {
              var variant_id = $('.sampleform select[name=id]').val();
              if (!variant_id) {
                variant_id = $('.sampleform input[name=id]').val();
              }
              var sampquantity = $('.sampleform input[name=quantity]').val();
              if (!sampquantity) {
                sampquantity = 1;
              }
              console.log('Sample Quantity:'+sampquantity)
              var title = $('.sample-name').html();
              var image = $('.sample-photo img').attr('src');

              doAjaxAddToCart(variant_id, sampquantity, title, image);
            }

            return false;
          });

        },

}

})(jQuery);

(function($) {  
  $(document).ready(function() {

    initAddToCart();
    initAddToCart2();
    qtyProduct();
    updateMiniCart();
    checkItemsInMiniCart();
  }); 

  function convertToSlug(text) {
    return text.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  } window.convertToSlug=convertToSlug;

  function showPopup(selector) {
    $(selector).addClass('active');
  } window.showPopup=showPopup;

  function hidePopup(selector) {
    $(selector).removeClass('active');
  } window.hidePopup=hidePopup;

  /* ADD TO CART */
  function doAjaxAddToCart(variant_id, quantity, title, image) {
  
  var properties = $('form[action="/cart/add"] [name^="properties"]').serialize();
  
    $.ajax({
      type: "post",
      url: "/cart/add.js",
      data: 'quantity=' + quantity + '&id=' + variant_id+ (properties ? '&' + properties : ''),
      dataType: 'json', 
      beforeSend: function() {              
//         showPopup('.loading');  
      },
      success: function(msg) {
        
        console.log('baaaaaaaaaaaaaaaaaaaaaaaal')
        
        if ($('.upsell-popup').length > 0) {
          
			showPopup('.upsell-popup');
          
        } else {

          if (typeof(upsell_main) === "function") {
            upsell_main();
          }
          if (typeof(upsell_offer) === "function") { 
            upsell_offer(); 
            jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
              /* Original success code here - triggers when the upsell pop-up is closed */ 

//               $('.product-popup').removeClass('wishlist-popup').addClass('cart-popup');
//               $('.product-popup').find('.product-name').html(title);
//               $('.product-popup').find('.product-image img').attr('src', image);
//               console.log('success upsell')
              //               showPopup('.product-popup');
              updateMiniCart();
              window.drawerCartManager.open();
            });
          } else { 
            /*Original success code here*/

//             $('.product-popup').removeClass('wishlist-popup').addClass('cart-popup');
//             $('.product-popup').find('.product-name').html(title);
//             $('.product-popup').find('.product-image img').attr('src', image);
//             console.log('success original')
            //             showPopup('.product-popup');
            updateMiniCart();
            window.drawerCartManager.open();
          }        


        }


      },
      error: function(xhr, text) {
        hidePopup('.loading'); 
        $('.error-message').text($.parseJSON(xhr.responseText).description);
        showPopup('.error-popup');
      }
    });
  }window.doAjaxAddToCart=doAjaxAddToCart;


  /* --------------------------------------------------------- */
  /* Ajax AddtoCart */



  /* Product item - Add To Cart */

  function initAddToCart() {
    $('.btn-addToCartCol').click(function(event) {    

      event.preventDefault();
      if ($(this).attr('disabled') != 'disabled') {
		var properties = $('form[action="/cart/add"] [name^="properties"]').serialize();
        var productItem = $(this).parents('.product-inner');
        var productId = $(productItem).attr('data-id'); 
         var form = $(this).parent(); 

        productId = productId.match(/\d+/g);

        var variant_id = $('.AddToCartForm-' + productId + ' select[name=id]').val();
        if (!variant_id) {
          variant_id = $('.AddToCartForm-' + productId + ' input[name=id]').val();
        }

        var quantity = $('.AddToCartForm-' + productId + ' input[name=quantity]').val();
        if (!quantity) {
          quantity = 1;
        }

        var title = $(productItem).find('.product-name').html();
        var image = $(productItem).find('.product-featured-image').attr('src');




        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: 'quantity=' + quantity + '&id=' + variant_id,
          dataType: 'json', 
          beforeSend: function() {              
            form.html('<div class="loader"><i class="icon-arrows-rotate-anti-dashed"></i></div>');
          },
          success: function(msg) {  
            $('.tooltip').remove();
            form.html('<a class="btn-added  product-add-cart" data-toggle="tooltip" data-placement="left" title="Added to cart !" href="/cart" ><i class="icon-ecommerce-bag-check"></i></a>');                                   
                      $('[data-toggle="tooltip"]').tooltip({container: 'body'});
            if (typeof(upsell_main) === "function") {
              upsell_main();
            }
            if (typeof(upsell_offer) === "function") { 
              upsell_offer(); 
              jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
                /* Original success code here - triggers when the upsell pop-up is closed */ 

//                 $('.product-popup').removeClass('wishlist-popup').addClass('cart-popup');
//                 $('.product-popup').find('.product-name').html(title);
//                 $('.product-popup').find('.product-image img').attr('src', image);
				
//                 showPopup('.product-popup');
                updateMiniCart();
                window.drawerCartManager.open();
              });
            } else { 
              /*Original success code here*/

//               $('.product-popup').removeClass('wishlist-popup').addClass('cart-popup');
//               $('.product-popup').find('.product-name').html(title);
//               $('.product-popup').find('.product-image img').attr('src', image);
				
              //               showPopup('.product-popup');
              updateMiniCart();
              window.drawerCartManager.open();
            }       

          },
          error: function(xhr, text) {
            hidePopup('.loading'); 
            $('.error-message').text($.parseJSON(xhr.responseText).description);
            showPopup('.error-popup');
          }
        });


      }
      return false;
    });
  }window.initAddToCart=initAddToCart;


  function initAddToCart2() {
    $('.btn-addToCart2').click(function(event) {

      event.preventDefault();
      console.log('baaaaal- 4');
      if ($(this).attr('disabled') != 'disabled') {

        var productItem = $(this).parents('.product-inner-fix');
        var productId = $(productItem).attr('id');           

        productId = productId.match(/\d+/g);


        var variant_id = $('#productSelect').val();
        if (!variant_id) {
          variant_id = $('#productSelect').val();
        }

        var quantity = $('.product-single-quantity #Quantity').val();
                console.log(quantity);
        if (!quantity) {
          quantity = 1;
        }
        console.log(quantity);



        var title = $(productItem).find('.product-name').html();
        var image = $(productItem).find('.more-views .owl-item.active img').attr('src');
        doAjaxAddToCart(variant_id, quantity, title, image); 
      }
      return false;
    });
  }window.initAddToCart=initAddToCart2;


  /* Update Mini Cart */
  function updateMiniCart() {
    Shopify.getCart(function(cart) {        
      doUpdateMiniCart(cart);
      console.log('cart items length => ', cart.items.length)
      if (cart.items.length) {
      	window.additionalProductChanged(cart.items)
      }
    });
  }window.updateMiniCart=updateMiniCart;

  /* Do Update Mini Cart */
  function doUpdateMiniCart(cart) {
    
    $('.number-cart').html(cart.item_count);
    var template = '<li class="item" id="cart-item-{id}"><a title="Remove this item" class="remove" href="#">×</a><a href="{url}" class="thumb-product"><img src="{img}" alt="{title}"></a><div class="widget-cart-title-product"><a href="{url}">{title}</a>{delivery}<span class="quantity">Quantity: {quantity}</span><span class="amount">{price}</span>{deliver_checkbox}</div></li>';

    $('.total .amount').html(Shopify.formatMoney(cart.total_price, window.money_format)); 
    $('.cart_list.product_list_widget').html('');

    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = template;
        item = item.replace(/\{id\}/g, cart.items[i].id);
        if (cart.items[i].id === 39303711621156) {
          item = item.replace(/\{url\}/g, `javascript:void(0)`);
        } else {
          item = item.replace(/\{url\}/g, cart.items[i].url);
        }
        item = item.replace(/\{title\}/g, cart.items[i].title);
        item = item.replace(/\{quantity\}/g, cart.items[i].quantity);
        item = item.replace(/\{img\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
        item = item.replace(/\{price\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
        
        if (cart.items[i].properties !== null && cart.items[i].properties.hasOwnProperty('Delivery')){
          var lineNumber = i+1;
          if (cart.items[i].properties.Delivery !== '') {
            item = item.replace(/\{delivery\}/g, '<span>Delivery: ' + cart.items[i].properties.Delivery + '</span>');
			item = item.replace(/\{deliver_checkbox\}/g, '<span><input type="checkbox" class="toggle_additional_product" data-line="'+ lineNumber +'" checked> White Glove Delivery ($149 per item)</span>');
          } else {
          	item = item.replace(/\{delivery\}/g, '');
            item = item.replace(/\{deliver_checkbox\}/g, '<span><input type="checkbox" class="toggle_additional_product" data-line="'+ lineNumber +'"> White Glove Delivery ($149 per item)</span>');
          }
        } else {
          item = item.replace(/\{delivery\}/g, '');
          item = item.replace(/\{deliver_checkbox\}/g, '');
        }
        
        item = item.replace()
        $('.cart_list.product_list_widget').append(item);
      }
      $('.cart_list .remove').click(function(event) {          
        event.preventDefault();       
        var productId = $(this).parents('.item').attr('id');
        productId = productId.match(/\d+/g);

        Shopify.removeItem(productId, function(cart) {
          updateMiniCart();
        });          
      });

    } 
    checkItemsInMiniCart();
  }window.doUpdateMiniCart=doUpdateMiniCart;

  /* Check Item Mini Cart */
  function checkItemsInMiniCart() {  


    if($('.cart_list.product_list_widget').children().length > 0) {

      $('.widget_shopping_cart_content').removeClass('noItem'); 

    } else{
      $('.widget_shopping_cart_content').addClass('noItem'); 

    }
  }window.checkItemsInMiniCart=checkItemsInMiniCart;

  function qtyProduct() { 
    $('.qtyplus').click(function(e){  
      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());

      if (!isNaN(currentVal)) {
        $('input[name='+fieldName+']').val(currentVal + 1);
      } else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });

    $(".qtyminus").click(function(e) {

      var fieldName = $(this).attr('data-field');
      var currentVal = parseInt($('input[name='+fieldName+']').val());
      if (!isNaN(currentVal) && currentVal > 1) {
        $('input[name='+fieldName+']').val(currentVal - 1);    } 
      else {
        $('input[name='+fieldName+']').val(1);
      }
      e.preventDefault();
    });
  }window.qtyProduct=qtyProduct;
  
  function additionalProductChanged(items) {
    console.log(items);
    var deliveryAddonId = 39303711621156;
    var deliverableItems = items.filter(item => item.properties && item.properties.hasOwnProperty('Delivery'));
    var deliveryEnabledItems = deliverableItems.filter(item => item.properties.Delivery === 'White Glove Service');
    
    var addonItems = items.filter(item => item.variant_id === deliveryAddonId);
    
    const reducer = (a, c) => a + c.quantity;
    const totalDeliveryItem = deliveryEnabledItems.reduce(reducer, 0);

    if (totalDeliveryItem === addonItems[0]?.quantity) return;
    if (totalDeliveryItem === 0 && addonItems.length === 0) return;
    
    console.log('delivery items => ', deliveryEnabledItems);
    console.log('addon items => ', addonItems)
    
    var newData = {
      updates: {
        39303711621156: totalDeliveryItem
      }
    }
    
    $.ajax({
      type: "POST",
      url: '/cart/update.js',
      data: newData,
      success: function(data) {
        updateMiniCart();
        if ($('body').hasClass('template-cart')) {
        	window.location.href = '';
        }
      },
      error: function(err) {
        console.log(err)
      },
      dataType: 'json'
    });
    
  };
  
  window.additionalProductChanged = additionalProductChanged;
  
//   $('.all_white_delivery').on('change', function() {
//   	const status = $(this).prop('checked');
    
//     const cart = JSON.parse(document.querySelector('#inpageCartJSON').innerHTML)
    
//     const cartItems = cart.items;
    
//     var deliverableItems = cartItems.filter(item => item.properties && item.properties.hasOwnProperty('Delivery'));
//     var deliverableVariantId = deliverableItems.map(item => item.variant_id);
//     var changeCount = 0;
//     for(var i = 0; i < cartItems.length;i++) {
//       if (deliverableVariantId.indexOf(cartItems[i].variant_id) !== -1) {
//         var line= i+1;
        
//         var updateData = {
//           'line': line,
//           'properties': { 
//             Delivery: status ? "White Glove Service" : null
//           }
//         }

//         $.ajax({
//           type: "POST",
//           url: '/cart/change.js',
//           data: updateData,
//           success: function(data) {
//             changeCount += 1;
//             if (changeCount === deliverableItems.length) {
//               Shopify.getCart(function(cart) {   
//                 console.log(cart)
//                 additionalProductChanged(cart.items);
//               });
//             }
//           },
//           error: function(err) {
//             console.log(err)
//           },
//           dataType: 'json'
//         });
//       }
//     }
    
    
//   })
  
  function toggleWhiteGloveProduct() {
    var $this = $(this);
    var line = $this.data('line');
	var status = $this.prop('checked');
    console.log(line, status)
    
    var updateData = {
      'line' : line,
      'properties': {
        Delivery: status? 'White Glove Service': null
      }
    }
    
    $.ajax({
      type: "POST",
      url: '/cart/change.js',
      data: updateData,
      success: function(data) {
        console.log(data);
        additionalProductChanged(data.items);
      },
      error: function(err) {
        console.log(err)
      },
      dataType: 'json'
    });
    
  }

  $(document).on('change', '.toggle_additional_product', toggleWhiteGloveProduct);

  $('#white_glover_atc').on('click', function(e) {
    e.preventDefault();
    
    $('#white_glove__checkbox').val("White Glove Service").prop('checked', true);
    $('#AddToCart').click();
	$('#white_glove__checkbox').val("").prop('checked', false);
    
//     $('#white_glove__checkbox').val("White Glove Service");
//     var id = $(this).closest('form').find('[name="id"]');
//     var cart_item = $('#cart-item-'+id.val());

//     if(cart_item.length && cart_item.find('.toggle_additional_product').length) {
//       cart_item.find('.toggle_additional_product').prop('checked', true).trigger('change');
//       $('.toggle-cart').click();
//     } else {
//       $('#AddToCart').click();
//     }
  })

})(jQuery);


(function($) {  

  $(document).ready(function() {
    quickView();


  }); 

  function quickView() {
    $('.btn-quickview').click(function() { 
      showPopup('.loading');
      var id = $(this).attr('data-id');
      var rating = (($(this).closest('.product-info').find('.spr-badge').attr('data-rating')) * 20)+"%";
      var templatesuffix = $(this).attr('product-template');
	  
      
      Shopify.getProduct(id, function(product) {
        var template = $('#quick-view').html();
        $('.quickview-product').html(template);
        var quickview = $('.quickview-product');
        quickview.find('.product-name a').html(product.title).attr('href', product.url);
        quickview.find('.spr-badge .spr-active').css({"width": rating});
        if (quickview.find('.des').length > 0) { 
          var description = product.description.replace(/(<([^>]+)>)/ig, "");        
          description = description.split(" ").splice(0, 20).join(" ") + "...";
          quickview.find('.des').text(description);
        } else { 
          quickview.find('.des').remove();
        }
         
        if (templatesuffix){
          $('.product-quantity.normal').html('<p>Price shown per Single Roll. Sold only as 2 Single Rolls (physically packaged as one large double roll). Price shown below x 2 =1 double roll.</p><label for="Quantity">Qty</label><div class="quantity-all"><select id="Quantity" name="quantitymulti" class="qty quantity form-control"><option value="2">Please Choose</option> <option value="2">2</option> <option value="4">4</option> <option value="6">6</option> <option value="8">8</option> <option value="10">10</option> <option value="12">12</option> <option value="14">14</option> <option value="16">16</option> <option value="18">18</option> <option value="20">20</option> <option value="22">22</option> <option value="24">24</option> <option value="26">26</option> <option value="28">28</option> <option value="30">30</option> <option value="32">32</option> <option value="34">34</option> <option value="36">36</option> <option value="38">38</option> <option value="40">40</option> <option value="42">42</option> <option value="44">44</option> <option value="46">46</option> <option value="48">48</option> </select></div></div><div class="total-price product-price f-left margin-right-20"><span></span></div>');
          $('.btn-addToCart').addClass('multi');
        }else {
          $('.product-quantity.normal').html('<label>Qty</label> <div class="quantity-all"> <span  class="qtyminus" data-field="quantity"><i class="fa  fa-caret-down"></i></span> <input type="text" name="quantity" value="1" class="qty quantity form-control"> <span class="qtyplus" data-field="quantity"><i class="fa fa-caret-up"></i></span> </div> <div class="total-price product-price f-left margin-right-20"> <span></span> </div>');
        }
        
        if(templatesuffix) {
           $('.product-quantity.normal').hide();
           $('.quickview-product .total-price').hide();
           $('.quickview-product .actions').hide();
      	}else{
           $('.product-quantity.normal').show();
           $('.quickview-product .total-price').show();
           $('.quickview-product .actions').show();
    	}
       
        
        console.log('temp: '+ templatesuffix);
        console.log('temp: '+ product.title);
        console.log('temp: '+ product.id);
		
          
        quickview.find('.product-category').html(product.type);
        quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
        quickview.find('.product-inner').attr('id', 'product-' + product.id);
        quickview.find('.variants').attr('id', 'product-actions-' + product.id);
        quickview.find('.variants select').attr('id', 'product-select-' + product.id);

        if (product.compare_at_price > product.price) {
          quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
          quickview.find('.price').addClass('on-sale');
        } else {
          quickview.find('.compare-price').html('');
          quickview.find('.price').removeClass('on-sale');
        }

        //out of stock
        if (!product.available) {
          quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
          quickview.find(".btn-addToCart").text('unavailable').addClass('disabled').attr("disabled", "disabled");;
        } else {
          quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));   

          engoQuickview.createQuickViewVariantsSwatch(product, quickview);        
        }

        qtyProduct();
     
        engoQuickview.quickViewSlider(product, quickview);
        engoQuickview.initQuickviewAddToCart();
        engoQuickview.initQuickviewAddToCartMulti();


        $('.quickview-product').addClass('active'); 
        $('.loading').addClass('loaded-content'); 

        if ($('.quickview-product .total-price').length > 0) {
          $('.quickview-product span[class=qtyplus]').on('click', engoQuickview.updatePricingQuickview);
          $('.quickview-product span[class=qtyminus]').on('click', engoQuickview.updatePricingQuickview);
        }

        quickview.find('.owl-carousel').owlCarousel({ 
          items: quickview.find('.owl-carousel').attr('data-items'),
          dots: false
        })


      });

    

      return false;  
    });  
  } window.quickView=quickView;
  var engoQuickview = { 
    /* Quick View SWATCH */
    createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
      if (product.variants.length > 1) { 
        var chon = [];
        var qmoney = [];
        var qimage = [];
        var qid = [];
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          qmoney.push(variant.price);
          qid.push(variant.id);
          if(variant.featured_image){
            qimage.push(variant.featured_image.src);
          }
          if( variant.available == false){
            chon.push(variant.id);

          }
          var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
          quickviewTemplate.find('form.variants > select').append(option);
        }



        var variant_id = $('.quickview-product select[name=id]').val();
        var check = false;

        for (var i = 0; i < chon.length; i++){
          if (chon[i] == variant_id){

            var check = true;
          }                       
          else{
          }
        }

        if(check == true){
          $('.quickview-product .btn-addToCart').attr('disabled','disabled');
          $('.hethang').html('<strong>SORRY THIS OPTION IS OUT OF STOCK, PLEASE CHOOSE OTHER OPTIONS</strong>');
                             }
                             else{

                             $('.hethang').html('');

          $(".quickview-product .btn-addToCart").removeAttr("disabled");
        }


        new Shopify.OptionSelectors("product-select-" + product.id, {
          product: product,
          onVariantSelected: selectCallbackQuickview
        });

        var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
        var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
        var options = "";

        for (var i = 0; i < product.options.length; i++) {
          options += '<div class="swatch clearfix" data-option-index="' + i + '">';
          options += '<div class="header">' + product.options[i].name + '</div>';
          var is_color = false;
          if (/Color|Colour/i.test(product.options[i].name)) {
            is_color = true;
          }
          var optionValues = new Array();
          for (var j = 0; j < product.variants.length; j++) {
            var variant = product.variants[j];
            var value = variant.options[i];
            var valueHandle = convertToSlug(value);
            var forText = 'swatch-' + i + '-' + valueHandle;
            if (optionValues.indexOf(value) < 0) {
              //not yet inserted
              options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

              if (is_color) {
                options += '<div class="tooltip">' + value + '</div>';
              }
              options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : '') + ' />';

              if (is_color) {
                options += '<label for="' + forText + '" style="background-color: ' + valueHandle + ';"></label>';
              } else {
                options += '<label for="' + forText + '">' + value + '</label>';
              }
              options += '</div>';
              if (variant.available) {
                $('.quickview-product .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
              }
              optionValues.push(value);
            }
          }
          options += '</div>';
        }
        quickviewTemplate.find('form.variants > select').after(options);
        quickviewTemplate.find('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this)
          .closest('form')
          .find('.single-option-selector')
          .eq(optionIndex)
          .val(optionValue)
          .trigger('change');

          var variant_id = $('.quickview-product select[name=id]').val();

          var check = false;
          for (var i = 0; i < qid.length; i++){
            if (qid[i] == variant_id){                            
              var quantity = parseInt($('.quickview-product input[name=quantity]').val());
              var totalPrice = qmoney[i] * quantity;
              var gia = Shopify.formatMoney(qmoney[i], window.money_format); 
              var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);             
              console.log(qmoney[i]);
              console.log(totalPriceText);
              var totalPriceHtml = $('.quickview-product .price').html();


              $('.quickview-product .total-price span').html(totalPriceText);
              $('.quickview-product .price').html(gia);
            
              console.log(qimage[i]);
              if(qimage[i]){
                $('.quickview-product .featured-image img').attr('src',qimage[i]);
              }
              

            }
          }
          for (var i = 0; i < chon.length; i++){


            if (chon[i] == variant_id){             
              var check = true;
            }                       
            else{
            }
          }

          if(check == true){
            $('.quickview-product .btn-addToCart').attr('disabled','disabled');
            $('.hethang').html('<strong>SORRY THIS OPTION IS OUT OF STOCK, PLEASE CHOOSE OTHER OPTIONS</strong>');
                               }
                               else{

                               $('.hethang').html('');

            $(".quickview-product .btn-addToCart").removeAttr("disabled");
          }
          engoQuickview.updatePricingQuickview;
        });

        if (product.available && product.options.size > 1) {
          Shopify.optionsMap = {};
          Shopify.linkOptionSelectors(product);
        }

      } else {
        quickviewTemplate.find('form.variants > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants').append(variant_field);
      }
    },

    /* Quick View */
    createQuickViewVariants: function(product, quickviewTemplate) {
      if (product.variants.length > 1) {
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
          quickviewTemplate.find('form.variants > select').append(option);
        }

        new Shopify.OptionSelectors("product-select-" + product.id, {
          product: product,
          onVariantSelected: selectCallbackQuickview
        });
        $('.quickview-product .single-option-selector').selectize();
        $('.quickview-product .selectize-input input').attr("disabled", "disabled");

        if (product.options.length == 1) {
          $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
        }

        quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
          $(this).html(product.options[i].name);
        });

      } else {
        quickviewTemplate.find('form.variants > select').remove();
        var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
        quickviewTemplate.find('form.variants').append(variant_field);
      }



    },

    /* Quick View VIEWMORE Slider */
    quickViewSlider: function(product, quickviewTemplate) { 
      var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
      quickviewTemplate.find('.featured-image').append('<a title="'+ product.title +'" class="product-photo" href="' + product.url + '"><img src="' + featuredImage + '" alt="' + product.title + '"/><span class="loading" style="height: 100%; width: 100%; top:0; left:0 z-index: 999; position: absolute; display: none; background: url(' + window.loading_url + ') center no-repeat;"></span></a>');
      if (product.images.length > 2) { 
        var quickViewCarousel = quickviewTemplate.find('.more-views .owl-carousel');

        for (i in product.images) {
          var grande = Shopify.resizeImage(product.images[i], 'grande');
          var compact = Shopify.resizeImage(product.images[i], 'compact');
          var item = '<div class="item"><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '"  /></a></div>';
          quickViewCarousel.append(item); 
        }

        quickViewCarousel.find('a').click(function() {
          var featureImage = quickviewTemplate.find('.featured-image img');
          var moreviewLoad = quickviewTemplate.find('.featured-image .loading');
          if (featureImage.attr('src') != $(this).attr('data-image')) {
            featureImage.attr('src', $(this).attr('data-image'));
            moreviewLoad.show();
            featureImage.load(function(e) {
              moreviewLoad.hide();
              $(this).unbind('load');
              moreviewLoad.hide();
            });
          }
        });

      } else {
        quickviewTemplate.find('.more-views').remove();
      }

    },

    /* Quick View ADD TO CART */
    initQuickviewAddToCart: function() {
      if ($('.quickview-product .btn-addToCart').length > 0) {
        $('.quickview-product .btn-addToCart').click(function() {
          var variant_id = $('.quickview-product select[name=id]').val();
          if (!variant_id) {
            variant_id = $('.quickview-product input[name=id]').val();
          }
          
       	  var qvquantity = '';
         
          var qvquantity = $('[name="quantity"]').val();

          if (!qvquantity) {
            qvquantity = 1;
          }
 		  console.log('Quickview Quantity:'+qvquantity);
          var title = $('.quickview-product .product-name a').html();
          var image = $('.quickview-product .featured-image img').attr('src');

          doAjaxAddToCart(variant_id, qvquantity, title, image);
          hidePopup('.quickview-product');          
        });
      }
    },
    initQuickviewAddToCartMulti: function() {
        $('.quickview-product .btn-addToCart.multi').click(function() {
          var variant_id = $('.quickview-product select[name=id]').val();
          if (!variant_id) {
            variant_id = $('.quickview-product input[name=id]').val();
          }
          
       	  var qvquantity = '';
         
          var qvquantity = $('select[name="quantitymulti"]').val();

 		  console.log('Quickview Quantity:'+qvquantity);
          var title = $('.quickview-product .product-name a').html();
          var image = $('.quickview-product .featured-image img').attr('src');

          doAjaxAddToCart(variant_id, qvquantity, title, image);
          hidePopup('.quickview-product');          
        });
    },

    /* Quick View update Pricing */
    updatePricingQuickview: function() {     
      var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
      var unitPriceTextMatch = $('.quickview-product .price').text().match(regex);


      if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = $('.quickview-product .price').text().match(regex);
      }


      if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var qvcquantity = parseInt($('.quickview-product input[name=quantity]').val());
        var totalPrice = unitPrice * qvcquantity;

        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
        if (!totalPriceText.match(regex)) {
          regex = /([0-9]+[.|,][0-9]+)/g;
        } 
        totalPriceText = totalPriceText.match(regex)[0];

        var regInput = new RegExp(unitPriceText, "g");
        var totalPriceHtml = $('.quickview-product .price').html().replace(regInput, totalPriceText);

        $('.quickview-product .total-price span').html(totalPriceHtml);
     
      }
    },

  }
  })(jQuery);

(function($) {  

  $(document).ready(function() {
    initWishlist();
    initProductWishlist();
    initRemoveWishlist();
  }); 

  function initWishlist() {
    $('.product-inner .add-to-wishlist').click(function(e) {
      e.preventDefault();
      var form = $(this).parent();  
      var productItem = $(this).parents('.product-inner');

      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          form.html('<div class="loader"><i class="icon-arrows-rotate-anti-dashed"></i></div>');
        },
        success: function(data) { 
         form.html('<a class="btn-added wishlist add-to-wishlist awe-button product-quick-whistlist added" href="/pages/wishlist" data-placement="left" data-toggle="tooltip" title="Go to wishlist"><i class="icon-basic-heart"></i></a>');            
          $('.tooltip').remove();
          $('[data-toggle="tooltip"]').tooltip({container: 'body'});
        },
        error: function(xhr, text) { 
          form.html('<a class="wishlist added" href="/pages/wishlist" title="Go to wishlist"><i class="icon-heart"></i></a>');   
          $('.error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.error-popup');
        }
      });
    });

  }window.initWishlist=initWishlist;


  function initProductWishlist() {
    $('.product-single .add-to-wishlist').click(function(e) {
      e.preventDefault();
     
      var form = $(this).parent();
      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          showPopup('.loading'); 
        },
        success: function(data) {
          hidePopup('.loading');  
          form.html('<a class="wishlist add-to-wishlist awe-button product-quick-whistlist added" href="/pages/wishlist" title="Go to wishlist"><i class="line wishlist"></i></a>');            
          var title = $('.product-name').html();
          var image = $('.product-featured-image').attr('src');
          $('.product-popup').find('.product-name').html(title);
          $('.product-popup').find('.product-image img').attr('src', image);
          $('.product-popup').find('.btn-wishlist').show();
          $('.product-popup').find('.btn-cart').hide();
          showPopup('.product-popup');


        },
        error: function(xhr, text) {
          hidePopup('.loading');    
          $('.error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.error-popup');  
        }
      });

    }); 
  };

  /* Remove Wishlist */
  function initRemoveWishlist() {
    $('.btn-remove-wishlist').click(function(e) {
      e.preventDefault();
      var row = $(this).parents('tr');
      var tagID = row.find('.tag-id').val();
      var form = jQuery('#remove-wishlist-form');
      form.find("input[name='contact[tags]']").val('x' + tagID);
      $.ajax({
        type: 'POST',
        url: '/contact',
        data: form.serialize(),
        beforeSend: function() {
          showPopup('.loading'); 

        },
        success: function(data) {
          row.fadeOut(1000);
          hidePopup('.loading');  
        },
        error: function(xhr, text) {
          $('.error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.error-popup');
        }
      });
    });
  };


})(jQuery);

(function($) {  

  $(document).ready(function() {
    collection.init();
  }); 

  if ($(".collection-sidebar")) {
    History.Adapter.bind(window, 'statechange', function() {
      var State = History.getState();
      if (!collection.fillterClick) {        
        collection.filterParams();
        var newurl = collection.filterCreateUrl();
        collection.filterGetContent(newurl);
        collection.resetFilter();
      }
      collection.fillterClick = false;
    });
  }


  var collection = { 
    init: function() {

      /* Collection Filter */
      this.initCollectionFilter();

      /* Collection Sorting */
      this.initCollectionSorting();

      /* Collection Show */
      this.initCollectionShow();

      /* Collection ViewMode */     
      this.initCollectionViewMode();

      /* Paging */
      this.initPaging();

    },


    /* --------------------------------------------------------- */
    

    /* Hide Dropdown */
    initToggle: function(){
//       $('.caret').click(function() {        
//         $(this).parent().next().toggleClass('active');        
//         return false; 
//       }); 

      $(".block-category .sub-menu > li").each( function(){
        if($(this).hasClass('active')){
          $(this).parent().addClass('active');
        }
      });

//       $('.dropdown-toggle').click(function() {
//         $('.dropdown-content').removeClass('active');
//         $(this).next().toggleClass('active');    
//         return false;              
//       });   
    },

    /* --------------------------------------------------------- */
    /* Categories Fillter */

    filterCategories: function() {
      $(".block-category.ajax a").click(function(e) {
        if (!$(this).hasClass('active')) {
          delete Shopify.queryParams.q;
          collection.filterAjaxClick($(this).attr('href'));
          $(".block-category.ajax a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },

    fillterTagEvents: function() {
      $('.filter-tag a:not(".clear"), .filter-tag label').click(function(e) {           
        var currentTags = [];
        if (Shopify.queryParams.constraint) {
          currentTags = Shopify.queryParams.constraint.split('+');     
        }  

        if (!window.filter_mul_choice && !$(this).prev().is(":checked")) {  
          var otherTag = $(this).parents('.filter-tag').find("input:checked");
          if (otherTag.length > 0) {
            var tagName = otherTag.val();
            if (tagName) {
              var tagPos = currentTags.indexOf(tagName);
              if (tagPos >= 0) {           
                currentTags.splice(tagPos, 1);
              }
            }
          }          
        }

        var tagName = $(this).prev().val();
        if (tagName) {
          var tagPos = currentTags.indexOf(tagName);
          if (tagPos >= 0) {            
            currentTags.splice(tagPos, 1);
          } else {
            currentTags.push(tagName);
          }
        }
        if (currentTags.length) {
          Shopify.queryParams.constraint = currentTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClearAll: function() {
      //clear all selection
      $('.refined-widgets a.clear-all').click(function(e) {
        delete Shopify.queryParams.constraint;
        delete Shopify.queryParams.q;
        collection.filterAjaxClick();
        e.preventDefault();
      });
    },

    filterMapClear: function() {
      $(".filter-tag").each(function() {
        var filterTag = $(this);
        if (filterTag.find("input:checked").length > 0) {
          //has active tag
          filterTag.find(".clear").show().click(function(e) {    
            var currentTags = [];
            if (Shopify.queryParams.constraint) {
              currentTags = Shopify.queryParams.constraint.split('+');
            }
            filterTag.find("input:checked").each(function() {
              var selectedTag = $(this);
              var tagName = selectedTag.val();
              if (tagName) {
                var tagPos = currentTags.indexOf(tagName);
                if (tagPos >= 0) {
                  //remove tag
                  currentTags.splice(tagPos, 1);
                }
              }
            });
            if (currentTags.length) {
              Shopify.queryParams.constraint = currentTags.join('+');
            } else {
              delete Shopify.queryParams.constraint;
            }
            collection.filterAjaxClick();
            e.preventDefault();
          });
        }
      });
    }, 

    filterParams: function() {
      Shopify.queryParams = {};
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },    

    filterMapEvents: function() {
      collection.fillterTagEvents();
      collection.filterCategories();
    },

    resetFilter: function() {
      $(".filter-custom .active, .filter-links .active").removeClass("active");
      $(".filter-tag input:checked").attr("checked", false);

      //category
      var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
      if (cat && cat[1]) {
        $(".filter-links a[href='" + cat[0] + "']").addClass("active");
      }
    },

    filterMapData: function(data) {
      var currentList = $(".collection-grid");
      if (currentList.length == 0) {
        currentList = $(".collection-list");
      }

      var productList = $(data).find(".collection-grid");
      if (productList.length == 0) {
        productList = $(data).find(".collection-list");
      }
      if (productList.length > 0 && productList.hasClass("products-grid")) {
        if (window.product_image_resize) {
          productList.find('img').fakecrop({
            fill: window.images_size.is_crop,
            widthSelector: ".products-grid .grid-item .product-image",
            ratioWrapper: window.images_size
          });
        }
      }
      currentList.replaceWith(productList);


      //replace view count
      if ($(".view-count").length > 0) {
        $(".view-count").replaceWith($(data).find(".view-count"));
      };
      
      //replace paging
      if ($(".padding").length > 0) {
        $(".padding").replaceWith($(data).find(".padding"));
      };

      $(".filter-block").replaceWith($(data).find(".filter-block"))
    },

    filterCreateUrl: function(baseLink) {
      var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      if (baseLink) {

        if (newQuery != "")
          return baseLink + "?" + newQuery;
        else
          return baseLink;
      }
      return location.pathname + "?" + newQuery;
    },       

    filterAjaxClick: function(baseLink) {
      delete Shopify.queryParams.page;  
      var newurl = collection.filterCreateUrl(baseLink);
      collection.fillterClick = true;
      History.pushState({
        param: Shopify.queryParams  
      }, newurl, newurl);
      collection.filterGetContent(newurl);         
    },        

    filterGetContent: function(newurl) {

      $.ajax({
        type: 'get',
        url: newurl, 
        beforeSend: function() {    
          showPopup('.loading'); 
        },

        success: function(data) {
          collection.filterMapData(data);               
           
          collection.filterMapClear();
          collection.filterMapClearAll();      

          collection.filterMapEvents(); 
          
           $('[data-toggle="tooltip"]').tooltip();

          collection.initPaging();
          collection.initToggle();
          quickView();
          initWishlist();
          initAddToCart();
          hidePopup('.loading'); 

        }, 

        error: function(xhr, text) {
          hidePopup('.loading')
          $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
          showPopup('.ajax-error-modal');
        }

      });
    },
    
    

    initCollectionFilter: function() {
      if ($(".collection-sidebar").length > 0) {
        collection.filterParams();
        collection.filterMapEvents();
        collection.filterMapClear();
        collection.filterMapClearAll();
      }
    },

    /* --------------------------------------------------------- */
    /* Collection Sorting */
    initCollectionSorting: function(e) {
     
     
      $(".collection-sorting a").click(function(e) {
        e.preventDefault();     
        if (!$(this).parent().hasClass("active")) {   
          Shopify.queryParams.sort_by = $(this).attr("href");
          collection.filterAjaxClick();          

          $(".collection-sorting li.active").removeClass("active");
          $(this).parent().addClass("active");
        }    
        var selected = $(this).text();   
        $(this).closest('.dropdown').find('.dropdown-label').text(selected);
        $(this).closest('.dropdown-content').removeClass('active');  

      });
    },


    /* --------------------------------------------------------- */
    /* Collection View Mode */
    initCollectionViewMode: function() {
      $(".view-mode a").click(function(e) {
        if (!$(this).hasClass("active")) {
          var paging = $(".collection-show .dropdown-label").text();
          if ($(this).hasClass("list")) {
            Shopify.queryParams.view = "list" + paging;
          } else {
            Shopify.queryParams.view = paging;
          }

          collection.filterAjaxClick();
          $(".view-mode a.active").removeClass("active");
          $(this).addClass("active");
        }
        e.preventDefault();
      });
    },


    /* --------------------------------------------------------- */
    /* Collection Show */
    initCollectionShow: function() {   
      $(".collection-show a").click(function(e) {  
        e.preventDefault();
        if (!$(this).parent().hasClass("active")) {
          var currentPage = $(this).attr('href'); 
          var view = $(".view-mode a.active").attr("data-mode");       
          if (view == "list") {
            Shopify.queryParams.view = "list" + currentPage;
          } else {
            Shopify.queryParams.view = currentPage;
          }
          collection.filterAjaxClick();
          $(".collection-show li.active").removeClass("active");
          $(this).parent().addClass("active");
          $(this).closest('.dropdown').find('.dropdown-label').text(currentPage);
          $(this).closest('.dropdown-content').removeClass('active');  
        }
      });
    },

    /* --------------------------------------------------------- */
    /* Paging */
    initPaging: function() {
      const totalCollectionCount = parseInt($('.total_collection_count').text());
      
      let fromPageItemCount = 0;
      let toPageItemCount = 0;
      
      let currentQUeryParams = Shopify.queryParams;
      
      if (currentQUeryParams) {
      	let currentPageNo = parseInt(currentQUeryParams.page);
        fromPageItemCount = ((currentPageNo - 1) * 60) + 1;
      }
      $(".pagination a").click(function(e) {
        var page = $(this).attr("href").match(/page=\d+/g); 
        if (page) {
          Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
          console.log(Shopify.queryParams.page)
          if (Shopify.queryParams.page) {
            var newurl = collection.filterCreateUrl();
            collection.fillterClick = true;
            History.pushState({
              param: Shopify.queryParams
            }, newurl, newurl);
            collection.filterGetContent(newurl);
            fromPageItemCount = ((Shopify.queryParams.page - 1) * 60) + 1;
            if (60 * Shopify.queryParams.page > totalCollectionCount) {
            	toPageItemCount = totalCollectionCount;
            } else {
            	toPageItemCount = 60 * Shopify.queryParams.page;
            }
            $('.page_collection_count').html(fromPageItemCount + ' to ' + toPageItemCount);
            //go to top
            $('body,html').animate({
              scrollTop: 0
            }, 600);

          }
        }
        e.preventDefault();
      });
    },

  }




  })(jQuery);






if (window.jQuery) var $ = window.jQuery;

$(function () {
  aweHosoren.init();

  //== DEMO ONLY
  aweSearchMenubar();
  
});


// ===

function aweSearchMenubar() {
  var $navbar = $('.awemenu-nav');

  var $searchForm = $('#menubar-search-form');
  var $openSearch = $('#open-search-form .icon-search');
  var $closeSearch = $('#close-search-form');

  $openSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.addClass('open');

    setTimeout(function() {
      $searchForm.find('input').focus();
    }, 250);
  });

  $closeSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.removeClass('open');
  });


  $(window).resize(function() {
    if ($navbar.hasClass('awemenu-mobile')) {
      $searchForm.width('100%');
      $searchForm.css({right: '0'});
    } else {
      var $awemenu = $('.awemenu-nav .awemenu');
      var $aweicon = $('.awemenu-nav .navbar-icons');

      var width = $awemenu.width() + 50;
      var offsetRight = $aweicon.width() + 20;

      $searchForm.width(width);
      $searchForm.css({right: offsetRight});
    }
  }).trigger('resize');

}

$(document).click(function (e){
  var container = $("#menubar-search-form");
  var container2=$("#open-search-form");
  if (!container.is(e.target) && !container2.is(e.target) && container.has(e.target).length === 0  && container2.has(e.target).length === 0){ 
    $('#menubar-search-form').removeClass('open');
  }
});


// ===
function aweMainSlider() {
  var $slider = $('.main-slider');

  $slider.owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    onInitialized: function() {
      $slider.find('.owl-item').each(function() {
        var $owlItem = $(this);

        var $mainSlide = $owlItem.find('.main-slider-item');
        var $mainImage = $owlItem.find('.main-slider-image > img');

        if ($mainSlide.length && $mainImage.length) {
          $mainSlide.addClass('background');
          $mainSlide.css('background-image', 'url('+$mainImage.attr('src')+')');

          $mainImage.css({
            opacity: 0,
            visibility: 'hidden'
          });
        }
      });
    }
  });
}

function awePriceSlider($selector) {
  if (! $selector) {
    $selector = $('#price-slider');
  }

  $selector.slider({
    values: [35, 250],
    min: 10,
    max: 320,
    step: 10,
    range: true,
    slide: function(e, ui) {
      $('#amount').text('$'+ui.value);
    }
  });
}

function aweBlogMasonry($selector) {
  if (! $selector) {
    $selector = $('.blog-masonry .row-masonry');
  }

  $selector.imagesLoaded(function() {
    $selector.masonry({
      itemSelector: '.column',
      columnWidth: '.column'
    });
  });
}

function aweProfolioIsotope($selector) {
  if (! $selector) {
    $selector = $('.grid');
  }

  $selector.imagesLoaded(function() {
    var $grid = $selector.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'masonry'
    });
  });

  $('.awe-nav').on('click', 'a', function(e) {
    e.preventDefault();

    $(this).parents('.awe-nav').find('li').removeClass('active');
    $(this).closest('li').addClass('active');

    var filter = $(this).attr('data-filter');
    $selector.isotope({ filter: filter });
  });
}

function aweProfolioDetail() {
  $('.lasted-portfolio-carousel').owlCarousel({
    items: 4,
    nav: true,
    dots: false,
    margin: 30,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      980: { items: 4 }
    }
  });

  $('.image').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: { enabled: true }
  });
}

function aweProductSidebar() {
  var $filterSidebar = $('#shop-widgets-filters');
  var $toggleButton = $('.open-filters');

  var $overlay = $('body').find('.widgets-filter-overlay');

  function _open() {
    $filterSidebar.addClass('open');
    $toggleButton.addClass('open');

    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }

    $('body').addClass('open-filters-open');
  }

  function _close() {
    $filterSidebar.removeClass('open');
    $toggleButton.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }

  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });

  $('html').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
}

function aweProductRender(thumbHorizontal) {
  if (Modernizr && ! Modernizr.touch) {
    $('.easyzoom').easyZoom();
  }

  var sMain = new Swiper('.product-slider-main', {
    loop: false,

    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  });

  var sThumb = new Swiper('.product-slider-thumbs', {
    loop: false,
    centeredSlides: true,
    spaceBetween: thumbHorizontal ? 15 : 0,
    slidesPerView: thumbHorizontal ? 4 : 3,
    direction: thumbHorizontal ? 'horizontal' : 'vertical',
    slideToClickedSlide: true
  });

  sMain.params.control = sThumb;
  sThumb.params.control = sMain;
}




var selectCallback = function(variant, selector) {
  if (variant) {
    if (variant.available) {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } else {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
    if ( variant.compare_at_price > variant.price ) {
      $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
    } else {
      $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
    }        
  } else {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}

$(".swiper-container").each( function(){
  var config = {
    spaceBetween: $(this).data('margin'),
    slidesPerView: $(this).data('items'),
    direction: $(this).data('direction'),
    paginationClickable: true,
    grabCursor: true 
  };    
  var swiper = new Swiper(this, config);

});


// ================== New lable=============
$('.product .product-inner').each(function(){

  var pubDate = $(this).data("publish-date");
  var pubDate2=pubDate.substr(0, 10);
  var todayDate = new Date();
  var time1 = Date.parse(pubDate2);
  var time2 = Date.parse(todayDate);
  var time= Math.abs(time2 - time1);
  var a= 302460601000;

  if(time < a){
    $(this).find('.new').show();

  }
});

$(document).ready(function(){
  if($(".product-body-list").children().length > 0){

    $('.view-mode .grid').removeClass('active');
    $('.view-mode .list').addClass('active');
  }
});

$('.tagcloud a').each(function(){ 
  var h1 =$(this).attr("href");    
  var h2 = h1.replace(' ',"-"); 
  $(this).attr('href',h2);

});


// Google maps 

$('.maps-vs').each(function() {
  console.log('aa');
  var $this = $(this),
      $id = $this.attr('id'),
      $zoom = parseInt($this.attr('data-zoom')),
      $latitude = $this.attr('data-latitude'),
      $longitude = $this.attr('data-longitude'),
      $address = $this.attr('data-address'),
      $info_title = $this.attr('data-info_title'),
      $phone = $this.attr('data-phone'),
      $email = $this.attr('data-email'),
      $website = $this.attr('data-website'),
      $map_type = $this.attr('data-map-type'),
      $pin_icon = $this.attr('data-pin-icon'),
      $pan_control = $this.attr('data-pan-control') === "true" ? true : false,
      $map_type_control = $this.attr('data-map-type-control') === "true" ? true : false,
      $scale_control = $this.attr('data-scale-control') === "true" ? true : false,
      $draggable = $this.attr('data-draggable') === "true" ? true : false,
      $zoom_control = $this.attr('data-zoom-control') === "true" ? true : false,
      $modify_coloring = $this.attr('data-modify-coloring') === "true" ? true : false,
      $saturation = $this.attr('data-saturation'),
      $hue = $this.attr('data-hue'),
      $lightness = $this.attr('data-lightness'),
      $styles;


  if ($modify_coloring == true) {
    var $styles = [{
      stylers:
      [
        {
          hue: $hue
        }, 
        {
          saturation: $saturation
        },
        {
          lightness: $lightness
        },
        {
          featureType: "landscape.man_made",
          stylers: [{
            visibility: "on"
          }]
        }
      ]
    }];
  }

  var map;

  function initialize()
  {            
    var bounds = new google.maps.LatLngBounds();
    var mapOptions = {
      zoom: $zoom,
      panControl: $pan_control,
      zoomControl: $zoom_control,
      mapTypeControl: $map_type_control,
      scaleControl: $scale_control,
      draggable: $draggable,
      scrollwheel: false,
      mapTypeId: google.maps.MapTypeId[$map_type],
      styles: $styles
    };

    map = new google.maps.Map(document.getElementById($id), mapOptions);
    map.setTilt(45);

    // Multiple Markers

    var markers = [];
    var infoWindowContent = [];

    if ($latitude != '' && $longitude != '') {
      markers[0] = [$address, $latitude, $longitude];

      var info_show_html = '';
      if ( $.trim( $info_title ) != '' ) {
        info_show_html += '<h4 class="map_info_title">' + $info_title + '</h4>';
      }

      if ( $.trim( $address ) != '' ) {
        info_show_html += '<p>' + $address + '</p>';
      }

      if ( $.trim( $phone ) != '' ) {
        info_show_html += '<i class="fa fa-phone"></i>' + $phone + '<br />';
      }

      if ( $.trim( $email ) != '' ) {
        info_show_html += '<i class="fa fa-envelope"></i><a href="mailto:' + $email + '">' + $email + '</a><br />';
      }

      if ( $.trim( $website ) != '' ) {
        info_show_html += '<i class="fa fa-globe"></i><a href="' + $website + '" target="_blank">' + $website + '</a><br />';
      }

      if ( $.trim( info_show_html ) != '' ) {
        info_show_html = '<div class="map_info_box">' + info_show_html + '</div>';
      }

      infoWindowContent[0] = [info_show_html];
    }

    var infoWindow = new google.maps.InfoWindow(), marker, i;

    for (i = 0; i < markers.length; i++)
    {
      var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
      bounds.extend(position);
      marker = new google.maps.Marker({
        position: position,
        map: map,
        title: markers[i][0],
        icon: $pin_icon
      });

      google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          if(infoWindowContent[i][0].length > 1) { 
            console.log(infoWindowContent[i][0]);
            infoWindow.setContent(infoWindowContent[i][0]);
          }

          infoWindow.open(map, marker);
        }
      })(marker, i));

      map.fitBounds(bounds);

    }

    var boundsListener = google.maps.event.addListener((map), 'bounds_changed', function(event) {
      this.setZoom($zoom);
      google.maps.event.removeListener(boundsListener);
    });                          
  }

  initialize();

  function googleMapsResize() {                          
    initialize();
  } 

  var temporaryTabsContainer = jQuery('.mk-tabs');
  if (temporaryTabsContainer.length) {
    temporaryTabsContainer.each(function() {
      google.maps.event.addDomListener($(this)[0], "click", googleMapsResize);
    });

  }

  var fullHeight = $this.hasClass('full-height-map');
  function fullHeightMap()
  {
    if (fullHeight)
    {
      var $window_height = jQuery(window).outerHeight(), wp_admin_height = 0, header_height = 0;
      if(jQuery.exists('#mk-header .mk-header-holder')) {
        header_height = parseInt(jQuery('#mk-header').attr('data-sticky-height'));  
      }   

      if (jQuery.exists("#wpadminbar")) {
        var wp_admin_height = jQuery("#wpadminbar").outerHeight();
      }

      $window_height = $window_height - wp_admin_height - header_height;
      $this.css('height', $window_height);
    }
  }

  fullHeightMap();
  jQuery(window).on('debouncedresize', fullHeightMap);
});


$('.collection-sidebar .filter-tag').each(function(){
  var le = $(this).find('.widget-content ul');
  console.log(le.children().length);
  if ( le.has('li')) {
    $(this).css('display','block');
  } else{
    $(this).css('display','none');
  }
});


//Mobile header top fixed scripts
$(document).ready(function() {
  var header = $('#header');
  var top = header.offset().top;
  $(window).on('scroll', function() {
    if($(this).width() < 992 && $(this).scrollTop() > top) {
      header.addClass('fixed_at_top');
    } else {
      header.removeClass('fixed_at_top');
    }
  });

});

document.addEventListener('DOMContentLoaded', function() {
  $('.toggle-menu .caret').closest('a.daqq').on('click', function(e) {
    e.preventDefault();
    var submenu = $(this).closest('li').children('.sub-menu');
    if(submenu.hasClass('active')) {
      submenu.removeClass('active');
    } else {
      submenu.addClass('active');
    }
  })
});